var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1873 20.8933L17.8006 16H14.1873L8.80062 20.8933C7.29396 22.2533 6.80062 24.3467 7.53396 26.24C8.26729 28.12 10.054 29.3333 12.0673 29.3333H19.9206C21.9473 29.3333 23.7206 28.12 24.454 26.24C25.1873 24.3467 24.694 22.2533 23.1873 20.8933ZM18.4273 24.1867H13.574C13.0673 24.1867 12.6673 23.7733 12.6673 23.28C12.6673 22.7867 13.0806 22.3733 13.574 22.3733H18.4273C18.934 22.3733 19.334 22.7867 19.334 23.28C19.334 23.7733 18.9206 24.1867 18.4273 24.1867Z",
    fill: "#0082CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4662 5.76002C23.7329 3.88002 21.9462 2.66669 19.9329 2.66669H12.0662C10.0529 2.66669 8.26623 3.88002 7.5329 5.76002C6.8129 7.65335 7.30623 9.74669 8.8129 11.1067L14.1996 16H17.8129L23.1996 11.1067C24.6929 9.74669 25.1862 7.65335 24.4662 5.76002ZM18.4262 9.64002H13.5729C13.0662 9.64002 12.6662 9.22669 12.6662 8.73335C12.6662 8.24002 13.0796 7.82669 13.5729 7.82669H18.4262C18.9329 7.82669 19.3329 8.24002 19.3329 8.73335C19.3329 9.22669 18.9196 9.64002 18.4262 9.64002Z",
    fill: "#0082CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcise);
export default __webpack_public_path__ + "static/media/concise.6960585f4a3e4259eb06df7c91b1bd5d.svg";
export { ForwardRef as ReactComponent };